function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0044 8.84483C18.728 8.84483 18.5039 8.61323 18.5039 8.32759V6H12.4972C11.9443 6 11.4961 6.46319 11.4961 7.03448V18.4138C11.4961 18.9851 11.9443 19.4483 12.4972 19.4483H20.0055C20.5584 19.4483 21.0067 18.9851 21.0067 18.4138V8.84483H19.0044Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0055 19.4483C20.5584 19.4483 21.0066 18.9851 21.0066 18.4138C21.0066 18.9851 20.5584 19.4483 20.0055 19.4483Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7474 10.1379C12.7474 10.4236 12.9716 10.6552 13.248 10.6552C12.9719 10.6543 12.7483 10.4232 12.7474 10.1379Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0056 19.4483H19.2548C19.2548 20.3052 19.9271 21 20.7564 21C21.5857 21 22.2581 20.3052 22.2581 19.4483V18.4138H21.0067C21.0067 18.9851 20.5585 19.4483 20.0056 19.4483Z",
  fillOpacity: 0.9
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2547 19.4483V11.6897C19.2547 11.1184 18.8065 10.6552 18.2536 10.6552H13.2481C12.9716 10.6552 12.7475 10.4236 12.7475 10.1379V9.62069C12.7475 9.0494 12.2993 8.5862 11.7464 8.5862H8.74306C8.1902 8.5862 7.74194 9.0494 7.74194 9.62069V19.4483C7.74194 20.3052 8.41432 21 9.24361 21H20.7564C19.9271 21 19.2547 20.3052 19.2547 19.4483Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.0045 8.84483H21.0067L18.5039 6V8.32759C18.5039 8.61323 18.728 8.84483 19.0045 8.84483Z",
  fillOpacity: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2525 7.81035H12.7475C12.6093 7.81035 12.4972 7.69455 12.4972 7.55173C12.4972 7.4089 12.6093 7.29311 12.7475 7.29311H17.2525C17.3907 7.29311 17.5028 7.4089 17.5028 7.55173C17.5028 7.69455 17.3907 7.81035 17.2525 7.81035Z",
  fill: "#121212"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2526 8.84482H13.7487C13.6105 8.84482 13.4984 8.72903 13.4984 8.5862C13.4984 8.44338 13.6105 8.32758 13.7487 8.32758H17.2526C17.3908 8.32758 17.5029 8.44338 17.5029 8.5862C17.5029 8.72903 17.3908 8.84482 17.2526 8.84482Z",
  fill: "#121212"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2458 19.7069H10.2447C9.55385 19.706 8.99414 19.1277 8.99329 18.4138V17.3793C8.99329 17.2365 9.10535 17.1207 9.24356 17.1207C9.38178 17.1207 9.49384 17.2365 9.49384 17.3793V18.4138C9.49384 18.8423 9.83003 19.1897 10.2447 19.1897H11.2458C11.384 19.1897 11.4961 19.3055 11.4961 19.4483C11.4961 19.5911 11.384 19.7069 11.2458 19.7069Z",
  fill: "black"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b2dfdbc4.svg";
export { ForwardRef as ReactComponent };